import firebase from 'firebase/compat/app';
import withoutNulls from '../../api/search/withoutNulls';
import STORE_CONSTANTS from '../constants';

const fixedPeriodSchemeConverter = {
  toFirestore(
    period: FixedPeriods.ExtendedPeriod,
  ): firebase.firestore.DocumentData {
    return withoutNulls({ ...period });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<FixedPeriods.ExtendedPeriod>,
    options: firebase.firestore.SnapshotOptions,
  ): FixedPeriods.ExtendedPeriod {
    const data = {
      ...snapshot.data(options),
    };
    return data;
  },
};

const getFixedPeriodIntervalsRef = ({
  accountId,
  fixedPeriodId,
  db,
}: {
  accountId: string;
  fixedPeriodId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.FIXED_PERIODS_COLLECTION)
    .doc(fixedPeriodId)
    .collection('periods')
    .withConverter(fixedPeriodSchemeConverter);
};

export default getFixedPeriodIntervalsRef;
